import { useState, useEffect } from 'react';
import { Grid, Box, Tabs, Tab } from '@mui/material';
import PropTypes from 'prop-types';

// COMPONENTES
import Historial from './historial/Historial';
import Active from './active/Active';

// SERVICIOS 
import { getActiveEvents, getClosedEvents } from '../../services/safety_hos/safety.hos.service';

// =========================================
// COMPONENTE PERSONALIZADO
// =========================================

const CustomTabPanel = (props) => {

    const { children, value, index, ...other } = props;
    
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );

}

// =========================================
// PROP TYPES
// =========================================

CustomTabPanel.propTypes = {

    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,

};

// =========================================
// PROPS
// =========================================

const a11yProps = (index) => {

    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };

}

// =========================================

const Hos = () => {

    const [tabValue, setTabValue] = useState(0);
    const [activeEvents, setActiveEvents] = useState([]);
    const [closedEvents, setClosedEvents] = useState([]);

    // =========================================
    // FUNCION PARA CONTROLAR TABS
    // =========================================

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // =========================================
    // FUNCION PARA BUSCAR DATOS
    // =========================================

    const fetchData = async () => {

        const activeData = await getActiveEvents();
        const closedData = await getClosedEvents();

        setActiveEvents(activeData);
        setClosedEvents(closedData);

    }

    useEffect(() => {

        fetchData();

    }, []);

    // =========================================

    return (

        <Grid container>

            <Grid size={12} marginBottom={2}>

                <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
                    <Tab label="Activos"  {...a11yProps(0)}/>
                    <Tab label="Historial"  {...a11yProps(1)}/>
                </Tabs>

            </Grid>

            <Grid size={12}>

                <CustomTabPanel value={tabValue} index={0}>

                    <Active 
                        events={activeEvents}
                        refresh={fetchData}
                        // indicencias={catalogoIncidencias}
                        // highAlerts={highAlerts}
                        // updateHighAlerts={setHighAlerts}
                        // refresh={refreshActiveData}
                    />

                </CustomTabPanel>

                <CustomTabPanel value={tabValue} index={1}>

                    <Historial
                        events={closedEvents}
                    />

                </CustomTabPanel>

            </Grid>

        </Grid>

    )

}

export default Hos